import {  Route } from 'react-router-dom';

// Pages.
import ProjectPlanPage from 'pages/sun_capital/master-plane/U Green/E-S/plan/ProjectPlanPage';
import ProjectGalleryPage from 'pages/sun_capital/master-plane/U Green/E-S/gallery/ProjectGalleryPage';
import PaymentPage from 'pages/sun_capital/master-plane/U Green/E-S/payment/PaymentPage';
const Index = () => {
  return (
    <>
      <Route exact path={`/sun_capital/master-plan/u-green/E-S/plan`}>
        <ProjectPlanPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/u-green/E-S/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/u-green/E-S/payment`}>
        <PaymentPage />
      </Route>
    </>
  );
};

export default Index;
